// extracted by mini-css-extract-plugin
export default {"carousel":"AuthCarousel_carousel__EDzNG","slide":"AuthCarousel_slide__7dK8G","image":"AuthCarousel_image__MjryI","text":"AuthCarousel_text__F9r+1"};